import { render, staticRenderFns } from "./WowzaCreate.vue?vue&type=template&id=33d6481a&scoped=true"
import script from "./WowzaCreate.vue?vue&type=script&lang=js"
export * from "./WowzaCreate.vue?vue&type=script&lang=js"
import style0 from "./WowzaCreate.vue?vue&type=style&index=0&id=33d6481a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d6481a",
  null
  
)

export default component.exports